export type TCognitiveSkillsVersion = 'v1' | 'v2' | null;

export const isV2CognitiveSkillsVersion = (
  cognitiveSkillsVersion: TCognitiveSkillsVersion
) => {
  return cognitiveSkillsVersion === 'v2';
};

export const isV1CognitiveSkillsVersion = (
  cognitiveSkillsVersion: TCognitiveSkillsVersion
) => {
  return cognitiveSkillsVersion === 'v1';
};
